/* common.js */

$(document).ready(function()
{

    // top menu switcher
    function switchMenu () {
        if($('.menu-toggle input').is(':checked')) {
            $('.web-header__topright, .web-header__top').addClass('active');
        } else {
            $('.web-header__topright, .web-header__top').removeClass('active');
        }
    }

    // smooth scroll to sections - top menu

    $('.menu__top .nav-link').click(function(event) {
        event.preventDefault();
        $('.menu-toggle input').prop( 'checked', false );
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 800);
        switchMenu ();
    });

    // switch - top menu

    switchMenu ();

    $('.menu-toggle input').click(function() {
        switchMenu ();
    });
});
